import * as is from './is'
import Tip from '../utils/tip'

function getErrmsg(resp) {
  let msg = Config.errMsg.errorMap[resp.code] || resp.message || Config.errMsg.DEFAULT
  msg = msg.replace(/\n/g, '<br>')
  return msg
}

function makeError(resp) {
  const e = {}
  e.message = getErrmsg(resp)
  e.code = String(resp.code)
  return e
}
export default {
  ...is,
  makeService(request, options) {
    return new Promise(async (resolve, reject) => {
      try {
        if (options && options.loading) {
          Loading.show()
        }
        const resp = await request
        if (resp.code !== 200) {
          Loading.hide()
          if (options && options.passCode && options.passCode.length) {
            resolve(resp)
            if (options.passCode.includes(resp.code)) {
              resolve(resp)
            }
          } else {
            const e = makeError(resp)
            if (!options || !options.noTip) {
              Tip.error(e.message)
            }
            reject(e)
          }
        } else {
          resolve(resp)
        }
      } catch (e) {
        reject(e)
      } finally {
        if (options && options.loading) {
          Loading.hide()
        }
      }
    })
  },
  highLightKeywords(
    str = '',
    keywords = '',
    config = {
      splitter: '%',
      color: '#409eff'
    }
  ) {
    if (!str || !keywords) return str

    const metaKeys = ['+', '*', '?']
    const {
      splitter,
      color
    } = config
    const regKey = keywords
      .split(',')
      .reduce((prev, curr) => {
        const arrs = curr.split(splitter)
        return prev.concat(arrs)
      }, []) // 兼容多个过滤词
      .filter(w => !!w) // 过滤
      .map(w => `${metaKeys.includes(w) ? '\\' : ''}${w}`)
      .join('|')
    const reg = new RegExp(regKey, 'g')
    return str.replace(reg, $1 => `<span style="color: ${color}">${$1}</span>`)
  },
  sleep(ms = 500) {
    if (typeof ms !== 'number') {
      throw new Error('param must be a number')
    }
    return new Promise(resolve => {
      setTimeout(resolve, ms)
    })
  },
  /**
   * 点击复制文本
   * @param {string} text 文本值
   */
  copyByClick(text) {
    try {
      const input = document.createElement('input')
      document.body.appendChild(input)
      input.value = text
      input.select()
      document.execCommand('copy') // 执行浏览器复制命令
      Tip.success('已复制当前点击的文本')
      document.body.removeChild(input)
    } catch (e) {
      Tip.warn('复制当前点击文本失败')
    }
  },
  dateFormat(fmt, date) {
    date = new Date(date)
    let ret
    const opt = {
      'Y+': date.getFullYear().toString(),
      'M+': (date.getMonth() + 1).toString(),
      'D+': date.getDate().toString(),
      'H+': date.getHours().toString(),
      'm+': date.getMinutes().toString(),
      's+': date.getSeconds().toString()
    }
    for (const k in opt) {
      ret = new RegExp('(' + k + ')').exec(fmt)
      if (ret) {
        fmt = fmt.replace(
          ret[1],
          (ret[1].length === 1)
            ? (opt[k])
            : (opt[k].padStart(ret[1].length, '0'))
        )
      }
    }
    return fmt
  },
  // 移除参数
  delUrlParam(url, ref) {
    // 如果不包括此参数
    if (url.indexOf(ref) === -1) return url
    const arr_url = url.split('?')
    const base = arr_url[0]
    const arr_param = arr_url[1].split('&')
    let index = -1
    for (let i = 0; i < arr_param.length; i++) {
      const paired = arr_param[i].split('=')
      if (paired[0] === ref) {
        index = i
        break
      }
    }

    if (index === -1) {
      return url
    }
    arr_param.splice(index, 1)
    if (arr_param && arr_param.length > 0) {
      return base + '?' + arr_param.join('&')
    }
    return base
  },
  getQueryVariable(variable) {
    const query = window.location.search.substring(1)
    const vars = query.split('&')
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=')
      if (pair[0] === variable) {
        return pair[1]
      }
    }
    return (false)
  },
  getCookie(name) {
    let arr
    const
      reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
    // eslint-disable-next-line no-cond-assign
    if (arr = document.cookie.match(reg)) return decodeURIComponent(arr[2])
    return null
  },
  /**
   * 防抖
   * 触发高频事件后n秒内函数只会执行一次，如果n秒内高频事件再次被触发，则重新计算时间
   * @param {Function} fn 处理函数
   * @param {Number} [delay = 200] 延迟时间
   */
  debounce(fn, delay = 200) {
    let timer = null
    return function (...args) {
      clearTimeout(timer)
      timer = setTimeout(() => {
        fn.apply(this, args)
      }, delay)
    }
  },

  /**
   * 节流
   * 高频事件触发，但在n秒内只会执行一次，所以节流会稀释函数的执行频率
   * @param {Function} fn 处理函数
   * @param {Number} [delay = 200] 延迟时间
   */
  throttle(fn, delay = 200) {
    let isCanRun = true
    return function (...args) {
      if (!isCanRun) return
      isCanRun = false
      setTimeout(() => {
        fn.apply(this, args)
        isCanRun = true
      }, delay)
    }
  },
  /**
   * 上报日志
   * @param {Number} logID 数据打点ID
   * @param {Object} options 上报的数据
   * @param {Function} callback 成功的回调
   */
  reportLog(logID, options = {}) {
    let logImg = new Image()

    const info = sessionStorage.getItem('userInfo')

    const {
      uin = '', apiid = '', ver = '', country = '', lang = ''
    } = info ? JSON.parse(info) : {}

    const logURL = process.env.VUE_APP_ENV === 'production' ? 'https://tj2.mini1.cn/miniworld' : 'https://indevelop.mini1.cn:8088/miniworld'

    options = Object.assign({}, {
      _t: new Date().getTime(),
      v1: uin,
      v2: apiid,
      v3: ver,
      v4: country,
      v5: lang,
      v6: '__IP__'
    }, options)

    logImg.onload = function () {
      logImg = null
    }

    logImg.onerror = function () {
      logImg = null
    }

    const logParams = new URLSearchParams(options).toString()

    logImg.src = `${logURL}?k=${logID}&${logParams}`
  },
  /**
  * 获取用户头像URL
  * @param {Number|Object} headInfo
  * 说明：
  * 1、游戏登录态参数，取登录态中的headIndex
  * 2、密码登录取得的baseinfo，取baseinfo.RoleInfo
  * 3、验证码登录取，取返回值中的Model和SkinID参数，组装成字面量对象
  */
  getAvatarUrl(headInfo) {
    // 如果是从游戏内带的登录态，则直接使用带出来的id，因为游戏内已经算好id
    if (typeof headInfo === 'number') {
      return `https://image.mini1.cn/roleicon/${headInfo}.png`
    } if (headInfo !== null && typeof headInfo === 'object') {
      // 皮肤ID映射
      const skinHeadIdMap = {
        10: 39,
        9: 38,
        8: 37,
        6: 35,
        7: 36,
        5: 34,
        4: 33,
        3: 30,
        2: 32,
        1: 31
      }

      let resultID = 0
      const skinID = +headInfo.SkinID

      if (skinID <= 0) {
        // 没有皮肤使用Model
        resultID = +headInfo.Model
      } else {
        // 有皮肤且存在于映射表中使用映射表中的id
        if (skinHeadIdMap[skinID]) {
          resultID = skinHeadIdMap[skinID]
        } else {
          // 不存在则使用skinid + 29
          resultID = skinID + 29
        }
      }
      return `https://image.mini1.cn/roleicon/${resultID}.png`
    }
    return 'https://image.mini1.cn/roleicon/1.png'
  }
}
